import type { IScheduledEmailContentV2 } from '@/types/email.types';

export const defaultCustomizations: IScheduledEmailContentV2 = {
  title: { base: '', changed: '' },
  description: { base: '', changed: '' },
  cta: { base: '', changed: '' },
  salutation: { base: '', changed: '' },
  startIntro: { base: '', changed: '' },
  subject: { base: '', changed: '' },
  headingFont: 'Arial',
  bodyFont: 'Arial',
  headingImage: '',
  mainImage: '',
  backgroundColor: '#fff',
  containerColor: '#fff',
  accentColor: '#eee',
  headingTextColor: '#000',
  bodyTextColor: '#000',
  secondaryAccentColor: '#ddd',
  secondaryBackgroundColor: '#fff',
  buttonTextColor: '#000',
  campaignTitle: '',
  templateId: 'basic',
};
